<!-- 我的产品列表 -->
<template>
<div style="min-width:1000px;">
    <div style="height:70px;">
      <span class="kzt span_font">
        我的产品
      </span></br>
      <span class="kzt_span span_font">您共有</span>
      <!-- <span class="kzt_span span_font">{{ num }}</span> -->
      <span class="kzt_span span_font">{{ total }}</span>
      <span class="kzt_span span_font">产品</span>
      <!-- <span class="kzt_span span_font">闲置产品</span>
      <span class="kzt_span span_font">{{ xz }}</span>
      <span class="kzt_span span_font">个</span> -->
      
      <!--bug 154 【狄诺尼云】【用户端】用户端应不显示禁用产品及过期产品 -->
      <!-- <span class="kzt_span span_font">已过期</span>
      <span class="kzt_span span_font">{{ gq }}</span>
      <span class="kzt_span span_font">个。</span> -->

    </div>
    <!-- 147 【狄诺尼云】【用户端】即将过期产品提示信息错误 -->
    <div class="title_div" v-show="title_div">
      有 {{ jgq }} 个产品即将过期，为了避免影响您的使用，请尽快续费！
    </div>
    <section>
        <!--列表-->
        <el-table :data="productList" highlight-current-row v-loading="listLoading"  style="width: 100%;" 
          :header-cell-style="getRowClass" @sort-change="handleSortChange">
          <el-table-column type="index" :index="indexMethod" label="序号" width="100">
            <template slot-scope="scope">
              <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productname" label="产品" min-width="160" sortable="custom" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="acountType" label="授权来源" min-width="120" sortable="custom" show-overflow-tooltip>
          </el-table-column>
          <!-- <el-table-column prop="usingstatusname" label="状态" min-width="100" sortable="custom" show-overflow-tooltip >
          </el-table-column> -->
          <el-table-column prop="usingstatusname" sortable="custom" label="状态" min-width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.usingstatusname === '正常使用' ? 'success' : 'warning'"
                disable-transitions>{{scope.row.usingstatusname}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="typename" label="类型" min-width="100"  sortable="custom" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="duetime1" label="到期时间" width="160" sortable="custom" show-overflow-tooltip>
          </el-table-column>
        </el-table>
     </el-dialog>
     <!--工具条-->
      <el-col :span="24" class="toolbar" style="border:1px solid #dfe6ec;">
        <el-pagination 
          background
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50,100]"
          :current-page="pageNumber"
          @current-change="handleCurrentChange" 
          @size-change="handleSizeChange"
          :page-size="pageSize" 
          :total="total" 
          style="float:right;">
        </el-pagination>
      </el-col>
	</section>
  <!-- <div class="ftBox">
    <div class="ft">
      <p>CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. <a href="https://beian.miit.gov.cn/" style="color: #666;" >苏ICP备18062906</a></p>
    </div>
  </div> -->
</div>
</template>
<script>
import { API__code, API__product,API__trial,API_wePro,API_Man } from '../../../api/index.js'
export default {
  data(){
    return {
      title_div:false,
      token:'',
      checkCode:'',
      id:'',
      productList:[],
      listLoading:false,
      pageNumber: 1,
      total: 0,
      pageSize:10,
      orderType:'',
      orderStr:'',
      num:0,
      // xz:0,
      gq:0,
      jgq:0,

    }
  },
  methods: {
    filterTag(value, row) {
      return row.tag === value;
    },
    handleSortChange:function(val){
      if(val){
        if(val.prop == "productname"){
          this.orderStr = "productnamepx";
        }else if(val.prop == "usingstatusname"){
          this.orderStr = "usingstatusnamepx";
        }else if(val.prop == "typename"){
          this.orderStr = "typenamepx";
        }else if(val.prop == "duetime1"){
          this.orderStr = "duetimepx";
        }else if(val.prop == "acountType"){
          this.orderStr = "acountTypepx";
        }
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getProductList();
    },
    imgs:function(){
      API__product.productListImg()
      .then((res)=>{
        this.dsrc = res.data.data;
      })
    },
    getProductList:function(val){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        listType:'page',
        userid:this.id,
        orderType:this.orderType,
        orderStr:this.orderStr,
        status: 1
      }
      this.listLoading = true
      API_wePro.getList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          for(var i=0;i<res.data.data.list.length;i++){
            if(res.data.data.list[i].duetime){
              res.data.data.list[i].duetime1 = res.data.data.list[i].duetime.substring(0,10);
            }
            if(res.data.data.list[i].companyid){
              res.data.data.list[i].acountType = '企业';
            }else{
              res.data.data.list[i].acountType = '个人';
            }
          }
          this.productList = res.data.data.list;
          this.total = res.data.data.totalRow;
         
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
         this.listLoading = false;
      }).catch(err =>{
         this.listLoading = false;
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    
    indexMethod(index) {
			return (index+1)+(this.pageNumber-1)*this.pageSize;
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getProductList();
		},
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getProductList();
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
        if (rowIndex == 0) {
            return "background:#F5F7FA";
        } else {
            return "";
        }
    },
    
    // 获取个人即将过期（30天）产品总数
    getUserDueInMonthProductSum:function(){
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        userid:this.id,
      }
      API_Man.getUserDueInMonthProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.jgq = res.data.data[0].num;
          if(this.jgq > 0){
            this.title_div = true;
          }else{
            this.title_div = false;
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    //获取个人过期产品总数
    getUserDueProductSum:function(){
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        userid:this.id,
      }
      API_Man.getUserDueProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.gq = res.data.data[0].num;
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    //个人产品总数
    getUserProductSum:function(){
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        userid:this.id,
      }
      API_Man.getUserProductSum(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.num = res.data.data[0].num;
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },

    //读取cookie
    getCookie: function() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('='); //再次切割
            //判断查找相对应的值
            if (arr2[0] == 'dnnypt_token') {
                this.token = arr2[1]; //保存到保存数据的地方
            } else if (arr2[0] == 'dnnypt_checkCode') {
                this.checkCode = arr2[1];
            }
        }
      }
    },
  },
  created(){
    this.getCookie();
  },
  mounted() {
    this.getProductList();

    // 获取个人即将过期（30天）产品总数
    this.getUserDueInMonthProductSum();
    //获取个人过期产品总数
    this.getUserDueProductSum();
    //个人产品总数
    this.getUserProductSum();
  }, 
}
</script>
<style scoped>
.span_font{
  font-family: "思源黑体 CN Bold Bold";
}
.kzt{
  position: relative;
  top: -15px;
  left: 0px;
  font-size:20px;
  font-weight: bold;
  color:#666;
}
.kzt_span{
  position: relative;
  top: 0px;
  left: 6px;
  font-size:14px;
  font-weight: Normal;
  color:#666;
}
.title_div{
    height: 42px;
    width: 475px;
    border-radius: 10px;
    color:#FFB300;
    font-size: 14px;
    font-weight: normal;
    background: rgb(255, 248, 225);
    position: relative;
    left: 5px;
    top: -10px;
    margin-bottom: 10px;
    line-height: 3;
    padding-left: 15px;
}
 
</style>



// WEBPACK FOOTER //
// ProductList.vue?877c7720